import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/workspace/components/NewsFeed/FeedShimmer.tsx");
